module.exports = __webpack_public_path__ + "static/media/2018_xmas_party.e4a9317b.jpg";